import { GlobalState } from "little-state-machine";

export const updateLoggingOut = (
  state: GlobalState,
  loggingOut : Boolean
) => ({
  ...state,
  loggingOut
});
